import { combineReducers } from 'redux';
import ReadNotificationReducer from '../components/Header/reducer/ReadNotificationReducer';
import ForgotPasswordReducer from '../modules/authentication/ForgotPassword/reducer/ForgotPasswordReducer';
import LoginReducer from '../modules/authentication/Login/reducer/LoginReducer';
import NewPasswordReducer from '../modules/authentication/NewPassword/reducer/NewPasswordReducer';
import FileRejectReducer from '../modules/authorization/Dashboard/reducer/FileRejectReducer';
import GetProofreaderDashboardReducer from '../modules/authorization/Dashboard/reducer/GetProofreaderDashboardReducer';
import AddSpeakerReducer from '../modules/authorization/Editor/reducer/AddSpeakerReducer';
import CheckForceUnclaimReducer from '../modules/authorization/Editor/reducer/CheckForceUnclaimReducer';
import DeleteSpeakerReducer from '../modules/authorization/Editor/reducer/DeleteSpeakerReducer';
import EditorDocumentReducer from '../modules/authorization/Editor/reducer/EditorDocumentReducer';
import EditorReducer from '../modules/authorization/Editor/reducer/EditorReducer';
import GetAllSpeakerReducer from '../modules/authorization/Editor/reducer/GetAllSpeakerReducer';
import ProofreaderRoleEditorSubmitReducer from '../modules/authorization/Editor/reducer/ProofreaderRoleEditorSubmitReducer';
import ProofreaderUnClaimReducer from '../modules/authorization/Editor/reducer/ProofreaderUnClaimReducer';
import RemoveUnusedSpeakerReducer from '../modules/authorization/Editor/reducer/RemoveUnusedSpeakerReducer';
import UpdateSpeakerReducer from '../modules/authorization/Editor/reducer/UpdateSpeakerReducer';
import VendorDetilsReducer from '../modules/authorization/Editor/reducer/VendorDetilsReducer';
import VendorNameListReducer from '../modules/authorization/Editor/reducer/VendorNameListReducer';
import VendorNextTranscriptReducer from '../modules/authorization/Editor/reducer/VendorNextTranscriptReducer';
import VendorProofreaderCommentReducer from '../modules/authorization/Editor/reducer/VendorProofreaderCommentReducer';
import VendorResolveProofreaderReducer from '../modules/authorization/Editor/reducer/VendorResolveProofreaderReducer';
import VendorRoleEditorSubmitReducer from '../modules/authorization/Editor/reducer/VendorRoleEditorSubmitReducer';
import GetProofreaderAllFilesListReducer from '../modules/authorization/Files/AllFiles/reducer/GetProofreaderAllFilesListReducer';
import GetProofreaderFilesFilterListReducer from '../modules/authorization/Files/AllFiles/reducer/GetProofreaderFilesFilterListReducer';
import GetProofreaderMyFilesListReducer from '../modules/authorization/Files/MyFiles/reducer/GetProofreaderMyFilesListReducer';
import GetMyMetricsListReducer from '../modules/authorization/MyMetrics/reducer/GetMyMetricsListReducer';
import ChnagePasswordReducer from '../modules/authorization/PersonalInformation/component/ChangePassword/reducer/ChangePasswordReducer';
import EditProfileReducer from '../modules/authorization/PersonalInformation/component/Profile/reducer/EditProfileReducer';
import GetProfileReducer from '../modules/authorization/PersonalInformation/component/Profile/reducer/GetProfileReducer';
import StateListReducer from '../modules/authorization/PersonalInformation/component/Profile/reducer/StateListReducer';
import GetVendorsFilterListReducer from '../modules/authorization/Vendors/reducer/GetVendorsFilterListReducer';
import GetVendorsListReducer from '../modules/authorization/Vendors/reducer/GetVendorsListReducer';
import saveSlateDataReducer from '../modules/authorization/Editor-Copy/reducer/saveSlateDataReducer';
import getSlateDataReducer from '../modules/authorization/Editor-Copy/reducer/getSlateDataReducer';
import restoreReducer from '../modules/authorization/Editor-Copy/reducer/restoreReducer';
import settingsReducer from '../modules/authorization/Editor-Copy/reducer/settingsReducer';
import findAndReplaceReducer from '../modules/authorization/Editor-Copy/saga/findAndReplaceReducer';
import GetCGAFilesListReducer from '../modules/authorization/Files/CGAFiles/reducer/GetCGAFilesListReducer';
import MergeCGAFileCollectionDownloadReducer from '../modules/authorization/Files/CGAFiles/reducer/MergeCGAFileCollectionDownloadReducer';
import SaveFileMergeStatusCGAReducer from '../modules/authorization/Files/CGAFiles/reducer/SaveFileMergeStatusCGAReducer';
import CgaFileStatesReducer from '../modules/authorization/Files/CGAFiles/reducer/CgaFileStatesReducer';
import CGAClientListReducer from '../modules/authorization/Files/CGAFiles/reducer/CGAClientListReducer';
import glossaryReducer from '../modules/authorization/Editor-Copy/reducer/glossaryReducer';

const rootReducer = combineReducers({
  loginUserData: LoginReducer,
  forgotPasswordData: ForgotPasswordReducer,
  newPasswordData: NewPasswordReducer,
  readnNotificationData: ReadNotificationReducer,
  userProfileDetails: GetProfileReducer,
  editUserProfileDetails: EditProfileReducer,
  stateList: StateListReducer,
  myMetrics: GetMyMetricsListReducer,
  fileReject: FileRejectReducer,
  editorDocument: EditorDocumentReducer,
  editorDetails: EditorReducer,
  CheckForceUnclaim: CheckForceUnclaimReducer,
  proofreaderUnClaim: ProofreaderUnClaimReducer,
  vendorsList: GetVendorsListReducer,
  proofreaderFileCount: GetProofreaderDashboardReducer,
  proofreaderAllFilesList: GetProofreaderAllFilesListReducer,
  proofreaderMyFilesList: GetProofreaderMyFilesListReducer,
  proofreaderFilesFilterList: GetProofreaderFilesFilterListReducer,
  vendorsFilterList: GetVendorsFilterListReducer,
  changePassword: ChnagePasswordReducer,
  vendorProofreaderComment: VendorProofreaderCommentReducer,
  vendorResolveProofreader: VendorResolveProofreaderReducer,
  vendorDetils: VendorDetilsReducer,
  vendorNameList: VendorNameListReducer,
  proofreaderRoleEditorSubmit: ProofreaderRoleEditorSubmitReducer,
  vendorNextTranscript: VendorNextTranscriptReducer,
  getAllSpeakers: GetAllSpeakerReducer,
  updateSpeaker: UpdateSpeakerReducer,
  deleteSpekaer: DeleteSpeakerReducer,
  addSpeaker: AddSpeakerReducer,
  removeUnusedSpeaker: RemoveUnusedSpeakerReducer,
  vendorRoleEditorSubmit: VendorRoleEditorSubmitReducer,
  saveSlateData: saveSlateDataReducer,
  slateData: getSlateDataReducer,
  restore: restoreReducer,
  settings: settingsReducer,
  findAndReplace: findAndReplaceReducer,
  cgaFilesList: GetCGAFilesListReducer,
  mergeCGAFileCollectionDownload: MergeCGAFileCollectionDownloadReducer,
  saveFileMergeStatusCGA: SaveFileMergeStatusCGAReducer,
  cgaFileStates: CgaFileStatesReducer,
  cgaClientList: CGAClientListReducer,
  glossary: glossaryReducer,
});

export default rootReducer;
